export default {
  methods: {
    localDeleteTagFromCard(tagId, cardId = this.currentCard.id) {
      this.$store.dispatch('localDeleteTagFromCard', {
        cardId,
        tagId,
      });
    },
    deleteTagFromCard(tag, cardId = this.currentCard.id) {
      this.localDeleteTagFromCard(tag.id, cardId);
      this.$store.dispatch('removeCardTag', { cardId, tagId: tag.id }).catch(() => {
        this.$store.dispatch('localAddTagToCard', {
          cardId,
          tag,
        });
      });
    },
  },
};
